
import { CREATE_ADMIN_FAILURE, CREATE_ADMIN_REQUEST, CREATE_ADMIN_SUCCESS, DELETE_ADMIN_FAILURE, DELETE_ADMIN_REQUEST, DELETE_ADMIN_SUCCESS, EDIT_ADMIN_FAILURE, EDIT_ADMIN_REQUEST, EDIT_ADMIN_SUCCESS, GET_ADMIN_FAILURE, GET_ADMIN_REQUEST, GET_ADMIN_SUCCESS } from "./adminTypes";
import Cookies from "universal-cookie";
import axios from "axios";
import Config from "../../config/index";
let baseUrl = Config.baseUrl;
let serviceDeskId = Config.serviceDeskId;

const cookies = new Cookies();
const userData = cookies.get("loginDetailsForSupport");

const getAdminRequest = () => {
    return {
      type: GET_ADMIN_REQUEST,
    };
  };
  
  const getAdminSuccess = (payload) => {
    return {
      type: GET_ADMIN_SUCCESS,
      payload: payload,
    };
  };
  
  const getAdminFaliure = (error) => {
    return {
      type: GET_ADMIN_FAILURE,
      payload: error,
    };
  };
  
  const getAdmin = (token) => {
    return (dispatch) => {
      dispatch(getAdminRequest());
      let url = `${baseUrl}/`;
      let config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      axios
        .get(url, config)
        .then((response) => {
          dispatch(getAdminSuccess(response.data.data));
        })
        .catch((err) => {
          dispatch(getAdminFaliure(err.message));
        });
    };
  };

  const createAdminRequest = () => {
    return {
      type: CREATE_ADMIN_REQUEST,
    };
  };
  
  const createAdminSuccess = (payload) => {
    return {
      type: CREATE_ADMIN_SUCCESS,
      payload: payload,
    };
  };
  
  const createAdminFaliure = (error) => {
    return {
      type: CREATE_ADMIN_FAILURE,
      payload: error,
    };
  };
  
  const createAdmin = (payload, token) => {
    return (dispatch) => {
      dispatch(createAdminRequest());
      let url = `${baseUrl}/`;
      let config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      return axios
        .post(url, payload, config)
        .then((response) => {
          dispatch(createAdminSuccess(response.data));
          return { status: true, data: response.data };
        })
        .catch((err) => {
          dispatch(createAdminFaliure(err.message));
          return { status: false, message: err.message };
        });
    };
  };


  const editAdminRequest = () => {
    return {
      type: EDIT_ADMIN_REQUEST,
    };
  };
  
  const editAdminSuccess = (payload) => {
    return {
      type: EDIT_ADMIN_SUCCESS,
      payload: payload,
    };
  };
  
  const editAdminFaliure = (error) => {
    return {
      type: EDIT_ADMIN_FAILURE,
      payload: error,
    };
  };
  
  const editAdmin = (payload, token) => {
    
    return (dispatch) => {
      dispatch(editAdminRequest());
      let url = `${baseUrl}/`;
      let config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      return axios
        .put(url, payload, config)
        .then((response) => {
          dispatch(editAdminSuccess(response.data));
          return { status: true, data: response.data };
        })
        .catch((err) => {
          dispatch(editAdminFaliure(err.response));
          return { status: false, data: err.response };
        });
    };
  };

  
const deleteAdminRequest = () => {
    return {
      type: DELETE_ADMIN_REQUEST,
    };
  };
  
  const deleteAdminSuccess = (payload) => {
    return {
      type: DELETE_ADMIN_SUCCESS,
      payload: payload,
    };
  };
  
  const deleteAdminFaliure = (error) => {
    return {
      type: DELETE_ADMIN_FAILURE,
      payload: error,
    };
  };
  
  const deleteAdmin = ( token) => {
    
    return (dispatch) => {
      dispatch(deleteAdminRequest());
      let url = `${baseUrl}/`;
      let config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      return axios
        .delete(url, {}, config)
        .then((response) => {
          dispatch(deleteAdminSuccess(response.data));
          return { status: true, data: response.data };
        })
        .catch((err) => {
          dispatch(deleteAdminFaliure(err.response));
          return { status: false, data: err.response };
        });
    };
  };

  export {
    getAdmin,
    createAdmin,
    editAdmin,
    deleteAdmin
  };

  